import _ from 'lodash'
import { InvoicingResponse } from '@/types/service-response'
import { InvoicingDetail } from '@/model/planning/InvoicingDetail'

export class InvoicingTree {
  private constructor (
    readonly name: string,
    readonly details: InvoicingDetail[],
    readonly children: InvoicingDetail[]
  ) {}

  public static createListFromResponse (data: InvoicingResponse): InvoicingTree[] {
    const details = _.uniqBy(data.Details, 'AdressNummer')
    return [
      new InvoicingTree(
        data.FullName,
        InvoicingDetail.createListFromResponse(data.Details.sort((a: any, b: any) => a.AdressNummer - b.AdressNummer)),
        InvoicingDetail.createListFromResponse(details.sort((a: any, b: any) => a.AdressNummer - b.AdressNummer))
      )
    ]
  }
}
